import { Routes } from '@angular/router';

export const mediaSettingsChildRoutes: Routes = [
  {
    path: '',
    children: [
      { path: '', redirectTo: 'overview', pathMatch: 'full' },
      {
        path: 'overview',
        loadComponent: () =>
          import('./components/media-settings/media-overview/media-overview.component').then((m) => m.MediaOverviewComponent),
      },
      {
        path: 'ad-slots',
        loadComponent: () =>
          import('./components/media-settings/media-ad-slots/media-ad-slots.component').then((m) => m.MediaAdSlotsComponent),
      },
      {
        path: 'statistics',
        loadComponent: () =>
          import('./components/media-settings/media-statistics/media-statistics.component').then((m) => m.MediaStatisticsComponent),
      },
    ],
  },
];
